<div matDialogTitle>{{data.title}}</div>
{{data.message}}
<div *ngIf="data.close" matDialogActions>
  <button color="primary" mat-raised-button>Stäng</button>
</div>
